<template>
	<svg :width="width" :height="height" viewBox="0 0 41 37" role="presentation" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M20.5204387,37 C26.8973081,37 31.8298438,35.444881 35.3180459,32.334643 C38.8062479,29.224405 40.6866068,24.921909 40.9591226,19.4271552 C41.0136258,18.8051076 41.0136258,18.1948924 40.9591226,17.5728448 C40.6866068,12.1299283 38.7789963,7.84039167 35.2362911,4.704235 C31.6935859,1.56807833 26.7883018,0 20.5204387,0 C14.1980724,0 9.26553672,1.56807833 5.72283151,4.704235 C2.18012629,7.84039167 0.272515786,12.1299283 0,17.5728448 L0,19.4271552 C0.272515786,24.921909 2.15287471,29.224405 5.64107677,32.334643 C9.12927883,35.444881 14.0890661,37 20.5204387,37 Z"
			class="bg"
			fill="#FF3D37"
		></path>
		<svg width="22" height="22" viewBox="0 0 22 22" fill="#000" xmlns="http://www.w3.org/2000/svg">
			<path
				transform="translate(9.500000, 7.500000)"
				d="M11.0001 2.47242C13.7788 2.47242 14.1079 2.48461 15.2007 2.53336C16.2163 2.57805 16.7648 2.74867 17.1304 2.89086C17.6138 3.07773 17.9632 3.30523 18.3248 3.6668C18.6904 4.03242 18.9138 4.37773 19.1007 4.86117C19.2429 5.2268 19.4135 5.7793 19.4582 6.79086C19.507 7.88773 19.5192 8.2168 19.5192 10.9915C19.5192 13.7702 19.507 14.0993 19.4582 15.1921C19.4135 16.2077 19.2429 16.7562 19.1007 17.1218C18.9138 17.6052 18.6863 17.9546 18.3248 18.3162C17.9592 18.6818 17.6138 18.9052 17.1304 19.0921C16.7648 19.2343 16.2123 19.4049 15.2007 19.4496C14.1038 19.4984 13.7748 19.5105 11.0001 19.5105C8.22135 19.5105 7.89229 19.4984 6.79947 19.4496C5.78385 19.4049 5.23541 19.2343 4.86979 19.0921C4.38635 18.9052 4.03697 18.6777 3.67541 18.3162C3.30979 17.9505 3.08635 17.6052 2.89947 17.1218C2.75729 16.7562 2.58666 16.2037 2.54197 15.1921C2.49322 14.0952 2.48104 13.7662 2.48104 10.9915C2.48104 8.21273 2.49322 7.88367 2.54197 6.79086C2.58666 5.77523 2.75729 5.2268 2.89947 4.86117C3.08635 4.37773 3.31385 4.02836 3.67541 3.6668C4.04104 3.30117 4.38635 3.07773 4.86979 2.89086C5.23541 2.74867 5.78791 2.57805 6.79947 2.53336C7.89229 2.48461 8.22135 2.47242 11.0001 2.47242ZM11.0001 0.599609C8.17666 0.599609 7.82322 0.611797 6.71416 0.660547C5.60916 0.709297 4.84947 0.888047 4.19135 1.14398C3.50479 1.41211 2.92385 1.76555 2.34697 2.34648C1.76604 2.92336 1.4126 3.5043 1.14447 4.1868C0.888535 4.84898 0.709785 5.60461 0.661035 6.70961C0.612285 7.82273 0.600098 8.17617 0.600098 10.9996C0.600098 13.823 0.612285 14.1765 0.661035 15.2855C0.709785 16.3905 0.888535 17.1502 1.14447 17.8084C1.4126 18.4949 1.76604 19.0759 2.34697 19.6527C2.92385 20.2296 3.50479 20.5871 4.18729 20.8512C4.84947 21.1071 5.6051 21.2859 6.7101 21.3346C7.81916 21.3834 8.1726 21.3955 10.996 21.3955C13.8195 21.3955 14.1729 21.3834 15.282 21.3346C16.387 21.2859 17.1467 21.1071 17.8048 20.8512C18.4873 20.5871 19.0682 20.2296 19.6451 19.6527C20.222 19.0759 20.5795 18.4949 20.8435 17.8124C21.0995 17.1502 21.2782 16.3946 21.327 15.2896C21.3757 14.1805 21.3879 13.8271 21.3879 11.0037C21.3879 8.18023 21.3757 7.8268 21.327 6.71773C21.2782 5.61273 21.0995 4.85305 20.8435 4.19492C20.5876 3.5043 20.2342 2.92336 19.6532 2.34648C19.0763 1.76961 18.4954 1.41211 17.8129 1.14805C17.1507 0.892109 16.3951 0.713359 15.2901 0.664609C14.177 0.611797 13.8235 0.599609 11.0001 0.599609Z"
				fill="black"
			/>
			<path
				transform="translate(9.500000, 7.500000)"
				d="M11.0001 5.6582C8.05077 5.6582 5.65796 8.05102 5.65796 11.0004C5.65796 13.9498 8.05077 16.3426 11.0001 16.3426C13.9495 16.3426 16.3423 13.9498 16.3423 11.0004C16.3423 8.05102 13.9495 5.6582 11.0001 5.6582ZM11.0001 14.4657C9.08671 14.4657 7.53483 12.9138 7.53483 11.0004C7.53483 9.08695 9.08671 7.53508 11.0001 7.53508C12.9136 7.53508 14.4655 9.08695 14.4655 11.0004C14.4655 12.9138 12.9136 14.4657 11.0001 14.4657Z"
				fill="black"
			/>
			<path
				transform="translate(9.500000, 7.500000)"
				d="M17.8008 5.44641C17.8008 6.13703 17.2401 6.6936 16.5536 6.6936C15.863 6.6936 15.3064 6.13297 15.3064 5.44641C15.3064 4.75578 15.867 4.19922 16.5536 4.19922C17.2401 4.19922 17.8008 4.75984 17.8008 5.44641Z"
				fill="black"
			/>
		</svg>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			ddefault: "",
		},
		width: {
			type: Number,
			default: 41,
		},
		height: {
			type: Number,
			default: 37,
		},
		fill: {
			type: String,
			default: "#FF3D37",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
